<template>
    <footer class="footer">
        <span @click="avisoBeta" class="buildDate">BETA {{ buildDate }}</span>
        <b-badge class="pwa-client" v-if="isPwaClient" variant="success"
            >Instalado</b-badge
        >
        <b-badge class="pwa-client" v-else variant="info">App não<br />instalado</b-badge>
        <img
            src="@/assets/inovaclickPngs/inovaclick.png"
            alt="Inovaclick"
            width="100px"
        />
    </footer>
</template>

<script>
import { BBadge } from "bootstrap-vue";

import { date } from "../../compilationTime.json";
import Swal from "sweetalert2";
export default {
    components: {
        BBadge,
    },
    data() {
        return {
            buildDate: date,
            isPwaClient: undefined,
        };
    },
    created() {
        this.isPwaClient = window.matchMedia("(display-mode: standalone)").matches;
    },
    methods: {
        avisoBeta() {
            Swal.fire({
                title: "Esta é uma aplicação BETA que ainda esta em desenvolvimento! Erros podem acontecer.",
                icon: "warning",
            });
        },
    },
};
</script>

<style scoped>
.footer {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #343a40;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
}

.buildDate {
    font-size: 10px;
    margin: 0;
    display: flex;
    margin-left: 5px;
    margin-top: -20px;
}

.pwa-client {
    font-weight: normal;
    margin: 0;
    padding: 2px;
    font-size: 12px;
}

span {
    margin: 10px;
    font-size: 13px;
    color: white;
}

img {
    margin: 10px;
}
</style>
